import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI';
import { EmployeeStateClass, EmployeeClass } from './interfaces/employeeClass'

const initialState: EmployeeStateClass = {
    isLoading: false,
    status: 'idle',
    employeeList: [],
    selectedRecord: {},
    isReload: false,
    isCanvasOpen: false,
    isCanvasLoading: false,
    currentPage: 1,
    accessToken: '',
    //pageSize: 10,
    start: 0,
    totalitems: 0,
    //search: "",
    accountemployeeid: 0,
    employeeTeamList: [],
    newRecords: [],
    removeRecords: [],
    //Pagination Start
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    sortOrder: 'asc',
    sortColumn: '4',
    isSearch: false,
    isShowGrid: false,
    //Pagination End
    email: "",
    isEmailUnique: true,
    columnIndex: 0,
    direction: "asc",
    isSelected: 0,
    IsDisabled: false,
    workTypeList: [],
    IsEmailAvailable: true,
    callEdit: false,
    IsDisabledValue:0,
     isAllChecked: false, 
    filterEmployeeName: '',
    filterEmailAddress: '',
    filterRoleId: 0,
    filterLocationId: 0,
    filterDepartmentId: 0,
    filterStatus: 0
}

interface IThunkApi {
    state: {
        employee: EmployeeStateClass;
        globalState: any;
    }
}

export const getAccountEmployeesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/getAccountEmployees',
        async (arg, thunkApi) => {
            //const { currentPage, pageSize, start, search } = arg;
            const { startRec, search, pageNo, pageSize, accessToken } = thunkApi.getState().employee;
            //const response = await fetchAPI('api/Projects/GetProjectDatatable/' + currentPage + '/' + pageSize + '/' + start + '/' + search, 'Get', '', true, 'ea443f7d-fedd-4bc6-a6ce-9d7c92740f8e');
            const response = await fetchAPI(`api/V2/Employees/GetEmployeeDatatable/${startRec}/${pageSize}/${pageNo}/${search}`, `Get`, '', true, 'ea443f7d-fedd-4bc6-a6ce-9d7c92740f8e');
            const json = await response.json();
            return json;
        }
    )

export const getEmployeesList = createAsyncThunk
<any, any, IThunkApi>
(
    'Employees/GetEmployeeDatatable',
    async (arg, thunkApi) => {
        const {currentPage, pageSize, start,search,EmployeeName,EmailAddress,RoleId,LocationId,DepartmentId,IsDisabled} = arg;
        const { sortColumn, sortOrder } = thunkApi.getState().employee; 
        const url = `api/V2/Employees/GetEmployeeDatatable/${currentPage}/${pageSize}/${start}` +
                    `?Order=${sortColumn}` +
                    `&OrderDir=${sortOrder}` +
                    `&search=${search || ' '}` +
                    `&EmployeeName=${encodeURIComponent(EmployeeName || '')}` +
                    `&EmailAddress=${encodeURIComponent(EmailAddress || '')}` +
                    `&RoleId=${RoleId ?? 0}` +
                    `&LocationId=${LocationId ?? 0}` +
                    `&DepartmentId=${DepartmentId ?? 0}` +
                    `&IsDisabled=${IsDisabled ?? 0}`;

        const response = await fetchAPI(url, 'Get', '', true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
        const json = await response.json();
        return json;
    }
);

export const GetEmailAddressValidationAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUsers/v2/GetEmailAddressValidation",
        async (arg, thunkApi) => {
            const { EMailAddress, AccountEmployeeId } = arg;
            // const response = await fetchAPI("api/v2/ExternalUsers/EmailAddressValidation/" + EMailAddress + "/" + AccountEmployeeId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ExternalUsers/EmailAddressValidation", "POST", { "EMailAddress": EMailAddress, "AccountEmployeeId": AccountEmployeeId }, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const getBillingAndEmployeeRateOfEmployeeOwnAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/getBillingAndEmployeeRateOfEmployeeOwn',
        async (arg, thunkApi) => {
            const { AccountWorkTypeId, AccountEmployeeId } = arg;
            const response = await fetchAPI(`api/V2/Employees/BillingAndEmployeeRateOfEmployeeOwn/${AccountEmployeeId}/${AccountWorkTypeId}`, `Get`, '', true, 'ea443f7d-fedd-4bc6-a6ce-9d7c92740f8e');
            const json = await response.json();
            return json;
        }
    )

export const isEmailAddressAvailable = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Employees/GetIsEmployeeExistsByEmailAddress',
        async (arg, thunkApi) => {
            const { email, accessToken } = thunkApi.getState().employee;
            const response = await fetchAPI(`api/V2/Employees/GetIsEmployeeExistsByEmailAddress/${email}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

// Simulated API call, replace with your actual API endpoint
const checkEmailUniquenessApi = async (email: any) => {
    const response = await fetch(`api/V2/Employees/GetIsEmployeeExistsByEmailAddress/${email}`);
    const data = await response.json();
    return data.isUnique;
};

export const checkEmailUniqueness = createAsyncThunk(
    'registration/checkEmailUniqueness',
    async (email, { rejectWithValue }) => {
        try {
            const isUnique = await checkEmailUniquenessApi(email);
            return isUnique;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const addAccountEmployeeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/addAccountEmployee',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Employees/', 'POST', arg, true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountEmployeeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/updateAccountEmployee',
        async (arg, thunkApi) => {
            const { AccountApprovalTypeId,
                AccountEmployeeId,
                ...argWithoutId } = arg;
            if (AccountApprovalTypeId === 0) {
                argWithoutId.AccountApprovalTypeId = null;
            } else {
                argWithoutId.AccountApprovalTypeId = AccountApprovalTypeId;
            }
            const response = await fetchAPI('api/V2/Employees/' + AccountEmployeeId, 'PUT', argWithoutId, true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountEmployeeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/deleteAccountEmployee',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Employees/' + arg, 'DELETE', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const deleteAllSelectedEmployeeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "accountEmployee/deleteAllSelectedEmployee",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Employees/MassDelete/', 'DELETE', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;

        }
    )

export const updateIsDisabledAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountEmployee/updateIsDisabledAsync',
        async (arg, thunkApi) => {
            const { AccountEmployeeId, ssnnoo, Country, ...argWithoutId } = arg;
            const response = await fetchAPI('api/V2/Employees/updateIsDisabledAsync/' + AccountEmployeeId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const UploadProfile = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/v2/UploadProfile',
        async (args, thunkApi) => {
            const { formData } = args;
            let response: any = "";
            response = await fetchAPI(`api/V2/Employees/UploadProfile`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
            const json = await response.json();
            return json;
        }
    )

export const UploadProfiles = createAsyncThunk<any, any, IThunkApi>(
    'Employees/v2/UploadProfileSingle',
    async (args, thunkApi) => {
        const { formData,EmployeeId } = args;
        try {
            const response = await fetchAPI(
                `api/V2/Employees/UploadProfileSingle/${EmployeeId}`,
                'POST',
                formData,
                true,
                'cce1c985-3054-43d2-b262-0731a14f3ca8',
                true
            );
            const json = await response.json();
            return json;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const UploadElectronicSignature = createAsyncThunk<any, any, IThunkApi>(
    'Employees/v2/UploadElectronicSignatureSingle',
    async (args, thunkApi) => {
        const { formData,EmployeeId } = args;
        try {
            const response = await fetchAPI(
                `api/V2/Employees/UploadElectronicSignatureSingle/${EmployeeId}`,
                'POST',
                formData,
                true,
                'cce1c985-3054-43d2-b262-0731a14f3ca8',
                true
            );
            const json = await response.json();
            return json;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const ResendVerificationEmailAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Employees/ResendVerificationEmail",
        async (arg, thunkApi) => {
            // const response = await fetchAPI("api/V2/Employees/ResendVerificationEmail/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/V2/Employees/ResendVerificationEmail", "POST", { "AccountEmployeeId": arg, "EmailURL": `${window.origin}/` }, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

    export const IsCurrentPasswordValidate = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Employees/GetIsCurrentpasswordvalidate',
        async (arg, thunkApi) => {
            const { email, accessToken } = thunkApi.getState().employee;
            const response = await fetchAPI(`api/V2/Employees/GetIsCurrentpasswordvalidate/${email}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

    export const updateIsDisabledBulkAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountEmployee/updateEmployeeStatusBulk',
        async (arg, thunkApi) => {
            // const { AccountEmployeeId, ssnnoo, Country, ...argWithoutId } = arg;
            const response = await fetchAPI('api/V2/Employees/updateEmployeeStatusBulk/', 'PUT', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

/*     export const UploadElectronicSignature = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/v2/UploadElectronicSignature',
        async (args, thunkApi) => {
            const { formData } = args;
            let response: any = "";
            response = await fetchAPI(`api/V2/Employees/UploadElectronicSignature`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
            const json = await response.json();
            return json;
        }
    ) */

export const employeeSlice = createSlice({
    name: 'employee',
    initialState,
    reducers: {
        updateAllSelectedAndUnSelected: (state, action: PayloadAction<any>) => {
            state.employeeTeamList = action.payload;
        },
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        updateAccountEmployeeIdInState: (state, action) => {
            state.accountemployeeid = action.payload;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageNo = action.payload.pageNumber;
            state.startRec = action.payload.start;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateAccountEmployeeId: (state, action: PayloadAction<any>) => {
            state.accountemployeeid = action.payload;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsCanvasLoading: (state, action: PayloadAction<boolean>) => {
            state.isCanvasLoading = action.payload;
            // state.isLoading = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        updateCallEdit:(state, action)=>{
            state.callEdit = action.payload;
        },
        checkedState: (state, action) => {
            const currentindex = state.employeeList.findIndex((item) => item.AccountEmployeeId == action.payload);
            const newArray = [...state.employeeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.employeeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.employeeList.findIndex((item) => item.AccountEmployeeId == action.payload);
            const newArray = [...state.employeeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.employeeList = newArray;
        },
        checkedAllState: (state, action) => {
            const newArray = state.employeeList.map((item) => ({
                ...item, // 
                isSelected: item.AccountEmployeeId !== action.payload ? 1 : item.isSelected,
            }));
            state.employeeList = newArray;
            state.isAllChecked = true;
        },
        unCheckedAllState: (state) => {
            const newArray = state.employeeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.employeeList = newArray;
            state.isAllChecked = false;
        },
        setSearchValue: (state, action) => {
            state.search = action.payload;
            state.currentPage = 1;
        },
        updateIsReloadInState: (state, action) => {
            state.isReload = action.payload;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.startRec = action.payload.start;
            state.pageSize = action.payload.pageSize;
            state.currentPage = action.payload.currentPage;
        },
        updateIsDisabledValue: (state, action: PayloadAction<any>) => {
            state.IsDisabledValue = action.payload;
        },
        setFilters: (state, action: PayloadAction<any>) => {
            state.filterEmployeeName = action.payload.EmployeeName;
            state.filterEmailAddress = action.payload.EmailAddress;
            state.filterRoleId = action.payload.RoleId;
            state.filterLocationId = action.payload.LocationId;
            state.filterDepartmentId = action.payload.DepartmentId;
            state.filterStatus = action.payload.IsDisabled;
            state.currentPage = 1; 
            state.start = 0;
        },
        
        resetFiltersState: (state) => {
            state.filterEmployeeName = "";
            state.filterEmailAddress = "";
            state.filterRoleId = 0;
            state.filterLocationId = 0;
            state.filterDepartmentId = 0;
            state.filterStatus = 0;
            state.currentPage = 1;
            state.start = 0;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmployeesList.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getEmployeesList.fulfilled, (state, action) => {
                state.employeeList = JSON.parse(action.payload.data);
                state.isShowGrid = JSON.parse(action.payload.data).length > 0 ? true : false;
                state.currentPage = action.payload.currentPage;
                state.pageNo = action.payload.currentPage;
                state.start = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.search;
                state.recordsFiltered = action.payload.recordsFiltered;
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = false;
                state.employeeList.map((item: any) => {
                    item.isSelected = 0
                });
            })
            .addCase(getEmployeesList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getBillingAndEmployeeRateOfEmployeeOwnAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getBillingAndEmployeeRateOfEmployeeOwnAsync.fulfilled, (state, action) => {
                //state.workTypeList = action.payload.AccountWorkType;
            })
/*             .addCase(getBillingAndEmployeeRateOfEmployeeOwnAsync.fulfilled, (state, action) => {
                //state.workTypeList = action.payload.AccountWorkType;
                    const decimalPlaces = action.meta.arg.decimalPlaces;

    const payload = action.payload;
    const employeeData = payload.AccountWorkType[0];
    const culture = action.meta.arg.cultureInfoName;
    console.log("employeeData", employeeData)

    let BillingRate = '';
    let EmployeeRate = '';

            if (employeeData.BillingRate !== null && employeeData.BillingRate !== undefined) {
                        BillingRate = Number(employeeData.BillingRate).toFixed(decimalPlaces);
            }
            if (employeeData.EmployeeRate !== null && employeeData.EmployeeRate !== undefined) {
                        EmployeeRate = Number(employeeData.EmployeeRate).toFixed(decimalPlaces);
            }

    if (culture === 'es-AR') {
        BillingRate = BillingRate.replace('.', ','); // Spanish: 6.50 → 6,50
        EmployeeRate = EmployeeRate.replace('.', ','); // Spanish: 6.50 → 6,50
    } else if (culture === 'en-US') {
        BillingRate = BillingRate.replace(',', '.'); // US: 6,50 → 6.50
        EmployeeRate = EmployeeRate.replace('.', ','); // Spanish: 6.50 → 6,50
    }

    state.selectedRecord = {
        ...employeeData,
        BillingRate: BillingRate,
        EmployeeRate: EmployeeRate,
    };

            }) */
            .addCase(getBillingAndEmployeeRateOfEmployeeOwnAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAccountEmployeeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountEmployeeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                
                state.isCanvasLoading = false;
            })
            .addCase(addAccountEmployeeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountEmployeeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountEmployeeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountEmployeeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(isEmailAddressAvailable.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(isEmailAddressAvailable.fulfilled, (state, action) => {
                state.employeeList = JSON.parse(action.payload.data);
                state.totalItems = action.payload.recordsTotal;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(isEmailAddressAvailable.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(checkEmailUniqueness.fulfilled, (state, action) => {
                state.isEmailUnique = action.payload;
            })
            .addCase(checkEmailUniqueness.rejected, (state, action) => {
            })
            .addCase(updateIsDisabledAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateIsDisabledAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(updateIsDisabledAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAllSelectedEmployeeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAllSelectedEmployeeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAllSelectedEmployeeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAccountEmployeeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountEmployeeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(deleteAccountEmployeeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(UploadProfiles.pending, state => {
                state.status = 'loading';
            })
            .addCase(UploadProfiles.fulfilled, (state, { payload }) => {
                state.status = 'idle';
            })
            .addCase(UploadProfiles.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(UploadElectronicSignature.pending, state => {
                state.status = 'loading';
            })
            .addCase(UploadElectronicSignature.fulfilled, (state, { payload }) => {
                state.status = 'idle';
            })
            .addCase(UploadElectronicSignature.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(ResendVerificationEmailAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(ResendVerificationEmailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (payload) {
                    state.isReload = true;
                }
                state.isLoading = false;
            })
            .addCase(ResendVerificationEmailAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetEmailAddressValidationAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetEmailAddressValidationAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.IsEmailAvailable = payload;
                // state.IsEmailAvailable = action.payload !== undefined ? action.payload : true;
                state.isLoading = false;
            })
            .addCase(GetEmailAddressValidationAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(IsCurrentPasswordValidate.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(IsCurrentPasswordValidate.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.IsEmailAvailable = payload;
                state.isLoading = false;
            })
            .addCase(IsCurrentPasswordValidate.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const {
    updateAllSelectedAndUnSelected, checkedState, unCheckedState, checkedAllState, unCheckedAllState,
    resetSelectedRecordObjectInState, updateAccountEmployeeIdInState, updatePagination, updateSearchPagination,
    updateIsCanvasLoading, updateAccountEmployeeId, updateIsLoading, setPageSize, setSearchValue, updateIsReloadInState, updateSorting, updateCallEdit,updateIsDisabledValue,
    setFilters, resetFiltersState
} = employeeSlice.actions
export const EmployeeState = (state: RootState) => state.employee
export default employeeSlice.reducer